const S = {
  wrapper: { marginTop:'10px', padding:'40px', border:'3px solid grey', fontFamily:"'Georgia', serif", color:'#1a1a2e', lineHeight:'1.7' },
  h1: { fontSize:'2rem', fontWeight:'700', borderBottom:'3px solid #c0392b', paddingBottom:'8px', marginBottom:'24px', color:'#7B0D0D' },
  h2: { fontSize:'1.3rem', fontWeight:'700', color:'#c0392b', marginTop:'36px', marginBottom:'12px', borderLeft:'4px solid #c0392b', paddingLeft:'10px' },
  p: { marginBottom:'12px', fontSize:'0.97rem' },
  infoBox: { background:'#FEF0F0', border:'2px solid #c0392b', borderRadius:'6px', padding:'16px 20px', margin:'16px 0' },
  infoBoxTitle: { fontWeight:'700', fontFamily:"'Courier New', monospace", fontSize:'0.88rem', color:'#7B0D0D', marginBottom:'8px' },
  infoBoxItem: { fontSize:'0.9rem', margin:'4px 0', paddingLeft:'12px', borderLeft:'2px solid #c0392b' },
  table: { width:'100%', borderCollapse:'collapse', marginBottom:'20px', fontSize:'0.92rem' },
  th: { background:'#c0392b', color:'#fff', padding:'10px 14px', textAlign:'left', fontWeight:'700', fontSize:'0.9rem' },
  tdE: { padding:'10px 14px', borderBottom:'1px solid #f0cece', verticalAlign:'top', background:'#fff5f5' },
  tdO: { padding:'10px 14px', borderBottom:'1px solid #f0cece', verticalAlign:'top', background:'#fff' },
  tdL: { fontWeight:'600', color:'#7B0D0D', whiteSpace:'nowrap', width:'220px' },
  code: { fontFamily:"'Courier New', monospace", fontSize:'0.88rem', whiteSpace:'pre-wrap' },
  dWrap: { margin:'24px 0', background:'#fffafa', border:'1px solid #f0cece', borderRadius:'8px', padding:'20px' },
  dTitle: { fontWeight:'700', fontSize:'0.95rem', color:'#7B0D0D', marginBottom:'12px', textAlign:'center', letterSpacing:'0.02em' },
  dCaption: { fontSize:'0.84rem', color:'#555', textAlign:'center', marginTop:'10px', fontStyle:'italic' },
};

function InfoBox({ title, items }) {
  return (
    <div style={S.infoBox}>
      <div style={S.infoBoxTitle}>{title}</div>
      {items.map((item, i) => <div key={i} style={S.infoBoxItem}>{item}</div>)}
    </div>
  );
}

function Table2({ rows }) {
  return (
    <table style={S.table}>
      <thead><tr>
        <th style={{ ...S.th, width:'220px' }}>Concept</th>
        <th style={S.th}>Explanation / Formula</th>
      </tr></thead>
      <tbody>
        {rows.map(([label, content], i) => (
          <tr key={i}>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.tdL }}>{label}</td>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.code }}>{content}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

// ── Diagram 1: Magnetic Field Around a Bar Magnet ─────────────────
function DiagramBarMagnet() {
  const W = 900, H = 360;

  // Field lines — pre-computed arcs from N to S around the magnet
  const cx = 450, cy = 180;
  const magW = 120, magH = 44;

  // Field lines as bezier curves looping from N pole to S pole
  const fieldLines = [
    // close loops top
    { d:`M ${cx+60},${cy-22} C ${cx+60},${cy-70} ${cx-60},${cy-70} ${cx-60},${cy-22}`, color:'#c0392b' },
    { d:`M ${cx+60},${cy+22} C ${cx+60},${cy+70} ${cx-60},${cy+70} ${cx-60},${cy+22}`, color:'#c0392b' },
    // medium loops
    { d:`M ${cx+60},${cy-10} C ${cx+120},${cy-120} ${cx-120},${cy-120} ${cx-60},${cy-10}`, color:'#e07b00' },
    { d:`M ${cx+60},${cy+10} C ${cx+120},${cy+120} ${cx-120},${cy+120} ${cx-60},${cy+10}`, color:'#e07b00' },
    // wide loops
    { d:`M ${cx+60},${cy-4} C ${cx+200},${cy-160} ${cx-200},${cy-160} ${cx-60},${cy-4}`, color:'#27ae60' },
    { d:`M ${cx+60},${cy+4} C ${cx+200},${cy+160} ${cx-200},${cy+160} ${cx-60},${cy+4}`, color:'#27ae60' },
    // very wide
    { d:`M ${cx+60},${cy} C ${cx+280},${cy-170} ${cx-280},${cy-170} ${cx-60},${cy}`, color:'#2E75B6' },
    { d:`M ${cx+60},${cy} C ${cx+280},${cy+170} ${cx-280},${cy+170} ${cx-60},${cy}`, color:'#2E75B6' },
  ];

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Bar Magnet — Magnetic Field Lines and Poles</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>

        {/* Field lines */}
        {fieldLines.map((fl, i) => (
          <path key={i} d={fl.d} fill="none" stroke={fl.color} strokeWidth="1.8" strokeDasharray="none" opacity="0.75"
            markerEnd="url(#arrowRed)"/>
        ))}

        {/* Arrow marker */}
        <defs>
          <marker id="arrowRed" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#c0392b" opacity="0.7"/>
          </marker>
        </defs>

        {/* Magnet body — South half */}
        <rect x={cx - magW} y={cy - magH/2} width={magW} height={magH} rx={4} fill="#2E75B6"/>
        <text x={cx - magW/2} y={cy + 5} textAnchor="middle" fontSize="22" fill="#fff" fontWeight="700">S</text>

        {/* Magnet body — North half */}
        <rect x={cx} y={cy - magH/2} width={magW} height={magH} rx={4} fill="#c0392b"/>
        <text x={cx + magW/2} y={cy + 5} textAnchor="middle" fontSize="22" fill="#fff" fontWeight="700">N</text>

        {/* Labels */}
        <text x={cx - magW/2} y={cy - magH/2 - 10} textAnchor="middle" fontSize="13" fill="#2E75B6" fontWeight="700">South Pole</text>
        <text x={cx + magW/2} y={cy - magH/2 - 10} textAnchor="middle" fontSize="13" fill="#c0392b" fontWeight="700">North Pole</text>

        {/* Right panel */}
        <rect x={720} y={10} width={170} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={805} y={30} textAnchor="middle" fontSize="14" fill="#7B0D0D" fontWeight="700">Field Line Rules</text>

        {[
          {y:42, bg:"#FEF0F0", bc:"#c0392b", text:["Exit from North pole","Enter at South pole"]},
          {y:98, bg:"#fff5e6", bc:"#e07b00", text:["Never cross each other","(unique direction at each point)"]},
          {y:154, bg:"#f0fff4", bc:"#27ae60", text:["Closer lines = stronger","field (higher density)"]},
          {y:210, bg:"#eaf3ff", bc:"#2E75B6", text:["Form closed loops","(no magnetic monopoles)"]},
          {y:266, bg:"#f5d0ff", bc:"#9b59b6", text:["Tangent = direction of","force on N test pole"]},
        ].map(({y, bg, bc, text}) => (
          <g key={y}>
            <rect x={726} y={y} width={158} height={50} rx={3} fill={bg} stroke={bc} strokeWidth="1"/>
            {text.map((t, i) => <text key={i} x={732} y={y + 18 + i*16} fontSize="11" fill="#333">{t}</text>)}
          </g>
        ))}

        {/* Axis labels */}
        <text x={20} y={cy - 60} fontSize="12" fill="#888" fontStyle="italic">Field lines</text>
        <text x={20} y={cy - 44} fontSize="12" fill="#888" fontStyle="italic">curve from</text>
        <text x={20} y={cy - 28} fontSize="12" fill="#888" fontStyle="italic">N → S</text>
      </svg>
      <div style={S.dCaption}>Magnetic field lines emerge from the North pole and re-enter at the South pole, forming continuous closed loops. Line density indicates field strength — closest near the poles. Field lines never intersect.</div>
    </div>
  );
}

// ── Diagram 2: Like vs Unlike Poles ──────────────────────────────
function DiagramPoleInteractions() {
  const W = 900, H = 300;
  const PW = (W - 30) / 2;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Magnetic Pole Interactions — Attraction and Repulsion</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>

        {/* Panel 1: Unlike poles — attract */}
        <rect x={10} y={10} width={PW} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={10 + PW/2} y={34} textAnchor="middle" fontSize="15" fill="#7B0D0D" fontWeight="700">Unlike Poles — Attract</text>

        {/* Left magnet: N on right */}
        <rect x={50} y={120} width={80} height={36} rx={3} fill="#2E75B6"/>
        <text x={90} y={143} textAnchor="middle" fontSize="16" fill="#fff" fontWeight="700">S</text>
        <rect x={130} y={120} width={80} height={36} rx={3} fill="#c0392b"/>
        <text x={170} y={143} textAnchor="middle" fontSize="16" fill="#fff" fontWeight="700">N</text>

        {/* Right magnet: S on left */}
        <rect x={240} y={120} width={80} height={36} rx={3} fill="#2E75B6"/>
        <text x={280} y={143} textAnchor="middle" fontSize="16" fill="#fff" fontWeight="700">S</text>
        <rect x={320} y={120} width={80} height={36} rx={3} fill="#c0392b"/>
        <text x={360} y={143} textAnchor="middle" fontSize="16" fill="#fff" fontWeight="700">N</text>

        {/* Attraction arrows */}
        <line x1={212} y1={138} x2={238} y2={138} stroke="#27ae60" strokeWidth="3"/>
        <polygon points="238,132 248,138 238,144" fill="#27ae60"/>
        <polygon points="212,132 202,138 212,144" fill="#27ae60"/>
        <text x={225} y={118} textAnchor="middle" fontSize="13" fill="#27ae60" fontWeight="700">ATTRACT</text>

        {/* Field lines curving between them */}
        <path d={`M 210,125 C 220,95 230,95 240,125`} fill="none" stroke="#c0392b" strokeWidth="1.5" opacity="0.6"/>
        <path d={`M 210,138 C 224,138 226,138 240,138`} fill="none" stroke="#c0392b" strokeWidth="1.5" opacity="0.6"/>
        <path d={`M 210,151 C 220,180 230,180 240,151`} fill="none" stroke="#c0392b" strokeWidth="1.5" opacity="0.6"/>

        <rect x={16} y={210} width={PW-12} height={72} rx={3} fill="#f0fff4" stroke="#27ae60" strokeWidth="1"/>
        <text x={22} y={228} fontSize="13" fill="#7B0D0D" fontWeight="700">Rule: Opposite poles attract</text>
        <text x={22} y={246} fontSize="12" fill="#444">North ↔ South: field lines connect</text>
        <text x={22} y={263} fontSize="12" fill="#444">smoothly between them — force</text>
        <text x={22} y={280} fontSize="12" fill="#444">pulls the magnets together.</text>

        {/* Panel 2: Like poles — repel */}
        <rect x={PW+20} y={10} width={PW} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={PW+20 + PW/2} y={34} textAnchor="middle" fontSize="15" fill="#7B0D0D" fontWeight="700">Like Poles — Repel</text>

        {/* Left magnet: N on right */}
        {(()=>{
          const ox = PW + 30;
          return <>
            <rect x={ox} y={120} width={80} height={36} rx={3} fill="#2E75B6"/>
            <text x={ox+40} y={143} textAnchor="middle" fontSize="16" fill="#fff" fontWeight="700">S</text>
            <rect x={ox+80} y={120} width={80} height={36} rx={3} fill="#c0392b"/>
            <text x={ox+120} y={143} textAnchor="middle" fontSize="16" fill="#fff" fontWeight="700">N</text>

            {/* Right magnet: N on left */}
            <rect x={ox+210} y={120} width={80} height={36} rx={3} fill="#c0392b"/>
            <text x={ox+250} y={143} textAnchor="middle" fontSize="16" fill="#fff" fontWeight="700">N</text>
            <rect x={ox+290} y={120} width={80} height={36} rx={3} fill="#2E75B6"/>
            <text x={ox+330} y={143} textAnchor="middle" fontSize="16" fill="#fff" fontWeight="700">S</text>

            {/* Repulsion arrows */}
            <line x1={ox+162} y1={138} x2={ox+140} y2={138} stroke="#c0392b" strokeWidth="3"/>
            <polygon points={`${ox+140},132 ${ox+130},138 ${ox+140},144`} fill="#c0392b"/>
            <line x1={ox+168} y1={138} x2={ox+208} y2={138} stroke="#c0392b" strokeWidth="3"/>
            <polygon points={`${ox+208},132 ${ox+218},138 ${ox+208},144`} fill="#c0392b"/>
            <text x={ox+185} y={118} textAnchor="middle" fontSize="13" fill="#c0392b" fontWeight="700">REPEL</text>

            {/* Repulsion field lines bowing outward */}
            <path d={`M ${ox+160},125 C ${ox+150},88 ${ox+130},75 ${ox+115},68`} fill="none" stroke="#c0392b" strokeWidth="1.5" opacity="0.6"/>
            <path d={`M ${ox+170},125 C ${ox+180},88 ${ox+200},75 ${ox+215},68`} fill="none" stroke="#c0392b" strokeWidth="1.5" opacity="0.6"/>
            <path d={`M ${ox+160},151 C ${ox+150},188 ${ox+130},200 ${ox+115},207`} fill="none" stroke="#c0392b" strokeWidth="1.5" opacity="0.6"/>
            <path d={`M ${ox+170},151 C ${ox+180},188 ${ox+200},200 ${ox+215},207`} fill="none" stroke="#c0392b" strokeWidth="1.5" opacity="0.6"/>

            <rect x={ox-4} y={210} width={PW-12} height={72} rx={3} fill="#FEF0F0" stroke="#c0392b" strokeWidth="1"/>
            <text x={ox+2} y={228} fontSize="13" fill="#7B0D0D" fontWeight="700">Rule: Like poles repel</text>
            <text x={ox+2} y={246} fontSize="12" fill="#444">North ↔ North: field lines bow</text>
            <text x={ox+2} y={263} fontSize="12" fill="#444">away from each other — force</text>
            <text x={ox+2} y={280} fontSize="12" fill="#444">pushes the magnets apart.</text>
          </>;
        })()}
      </svg>
      <div style={S.dCaption}>The fundamental rule of magnetism: unlike poles attract, like poles repel. This mirrors the behaviour of electric charges but with an important difference — magnetic poles always come in pairs (dipoles). Isolated magnetic monopoles have never been observed.</div>
    </div>
  );
}

// ── Diagram 3: Electromagnetism — Current & Magnetic Field ────────
function DiagramElectromagnetism() {
  const W = 900, H = 340;
  const PW = (W - 30) / 2;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Electromagnetism — Magnetic Fields Created by Electric Current</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>

        {/* Panel 1: Straight wire */}
        <rect x={10} y={10} width={PW} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={10+PW/2} y={30} textAnchor="middle" fontSize="15" fill="#7B0D0D" fontWeight="700">Straight Current-Carrying Wire</text>

        {/* Wire */}
        {(()=>{
          const wx = 10+PW/2;
          return <>
            <rect x={wx-6} y={40} width={12} height={220} rx={3} fill="#e07b00"/>
            {/* Current arrow */}
            <polygon points={`${wx-4},50 ${wx+4},50 ${wx},40`} fill="#fff"/>
            <text x={wx+14} y={58} fontSize="12" fill="#e07b00" fontWeight="700">I (current)</text>
            {/* Circular field lines */}
            {[40,65,90,115].map((r,i)=>(
              <circle key={r} cx={wx} cy={150} r={r} fill="none"
                stroke={['#c0392b','#e07b00','#27ae60','#2E75B6'][i]}
                strokeWidth="1.6" strokeDasharray="none" opacity="0.7"/>
            ))}
            {/* Direction dots/crosses on rings */}
            {[40,65,90].map((r,i)=>(
              <text key={r} x={wx+r+4} y={154} fontSize="14"
                fill={['#c0392b','#e07b00','#27ae60'][i]} fontWeight="700">⟳</text>
            ))}
            <text x={wx-PW/2+16} y={290} fontSize="12" fill="#7B0D0D" fontWeight="700">Right-Hand Rule:</text>
            <text x={wx-PW/2+16} y={307} fontSize="12" fill="#444">Thumb → current direction</text>
            <text x={wx-PW/2+16} y={322} fontSize="12" fill="#444">Fingers curl → field direction</text>
          </>;
        })()}

        {/* Panel 2: Solenoid */}
        <rect x={PW+20} y={10} width={PW} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={PW+20+PW/2} y={30} textAnchor="middle" fontSize="15" fill="#7B0D0D" fontWeight="700">Solenoid (Coiled Wire)</text>

        {(()=>{
          const ox = PW + 30;
          const sy = 160, coilH = 110, coilW = 280, turns = 6;
          const coilLeft = ox + 10, coilRight = coilLeft + coilW;
          const coilTop = sy - coilH/2, coilBot = sy + coilH/2;

          // Draw coil turns
          const turnW = coilW / turns;
          const coilTurns = Array.from({length: turns}, (_, i) => {
            const x1 = coilLeft + i * turnW;
            const x2 = x1 + turnW;
            const xm = (x1+x2)/2;
            return (
              <g key={i}>
                {/* front arc */}
                <path d={`M ${x1},${sy} C ${x1},${coilBot+12} ${x2},${coilBot+12} ${x2},${sy}`}
                  fill="none" stroke="#e07b00" strokeWidth="3"/>
                {/* back arc */}
                <path d={`M ${x1},${sy} C ${x1},${coilTop-12} ${x2},${coilTop-12} ${x2},${sy}`}
                  fill="none" stroke="#e07b00" strokeWidth="3" opacity="0.4"/>
              </g>
            );
          });

          return <>
            {coilTurns}
            {/* Internal uniform field lines */}
            {[-28,-10,8,26].map(dy=>(
              <line key={dy} x1={coilLeft+10} y1={sy+dy} x2={coilRight-10} y2={sy+dy}
                stroke="#2E75B6" strokeWidth="1.8" opacity="0.8"/>
            ))}
            {/* N and S labels */}
            <rect x={coilRight-2} y={sy-30} width={28} height={60} rx={3} fill="#c0392b"/>
            <text x={coilRight+12} y={sy+6} textAnchor="middle" fontSize="16" fill="#fff" fontWeight="700">N</text>
            <rect x={coilLeft-28} y={sy-30} width={28} height={60} rx={3} fill="#2E75B6"/>
            <text x={coilLeft-14} y={sy+6} textAnchor="middle" fontSize="16" fill="#fff" fontWeight="700">S</text>

            {/* External field loops */}
            <path d={`M ${coilRight+26},${sy} C ${coilRight+80},${sy-90} ${coilLeft-60},${sy-90} ${coilLeft-28},${sy}`}
              fill="none" stroke="#2E75B6" strokeWidth="1.5" opacity="0.5" strokeDasharray="5,3"/>
            <path d={`M ${coilRight+26},${sy} C ${coilRight+80},${sy+90} ${coilLeft-60},${sy+90} ${coilLeft-28},${sy}`}
              fill="none" stroke="#2E75B6" strokeWidth="1.5" opacity="0.5" strokeDasharray="5,3"/>

            {/* Arrow on internal field */}
            <polygon points={`${coilLeft+160},${sy-28} ${coilLeft+168},${sy-28} ${coilLeft+164},${sy-36}`} fill="#2E75B6"/>

            {/* Labels */}
            <text x={ox+PW/2-10} y={260} textAnchor="middle" fontSize="12" fill="#2E75B6" fontWeight="700">Uniform field inside</text>
            <text x={ox+PW/2-10} y={275} textAnchor="middle" fontSize="12" fill="#444">(like a bar magnet)</text>

            <rect x={ox-4} y={288} width={PW-16} height={40} rx={3} fill="#eaf3ff" stroke="#2E75B6" strokeWidth="1"/>
            <text x={ox+6} y={304} fontSize="12" fill="#1F3864" fontWeight="700">Field strength: B = μ₀nI</text>
            <text x={ox+6} y={320} fontSize="11" fill="#444" fontFamily="'Courier New',monospace">n = turns/metre, I = current (A)</text>
          </>;
        })()}
      </svg>
      <div style={S.dCaption}>A moving electric charge always produces a magnetic field. For a straight wire the field forms concentric circles (Right-Hand Rule). Winding wire into a solenoid concentrates the field inside into a uniform pattern identical to a bar magnet — this is the principle behind electromagnets.</div>
    </div>
  );
}

// ── Diagram 4: The Electromagnetic Spectrum / Earth's Magnetic Field ──
function DiagramEarthField() {
  const W = 900, H = 340;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Earth's Magnetic Field & Magnetic Declination</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>

        {/* Earth body */}
        <circle cx={320} cy={170} r={120} fill="#1a5276" opacity="0.15" stroke="#1a5276" strokeWidth="2"/>
        <circle cx={320} cy={170} r={120} fill="url(#earthGrad)" stroke="#2E75B6" strokeWidth="2"/>

        <defs>
          <radialGradient id="earthGrad" cx="40%" cy="40%">
            <stop offset="0%" stopColor="#5dade2"/>
            <stop offset="60%" stopColor="#1a5276"/>
            <stop offset="100%" stopColor="#0d2137"/>
          </radialGradient>
        </defs>

        {/* Geographic poles */}
        <line x1={320} y1={50} x2={320} y2={290} stroke="#bbb" strokeWidth="1.5" strokeDasharray="6,4"/>
        <text x={320} y={38} textAnchor="middle" fontSize="12" fill="#888">Geographic North</text>
        <text x={320} y={308} textAnchor="middle" fontSize="12" fill="#888">Geographic South</text>

        {/* Magnetic axis (tilted ~11°) */}
        <line x1={296} y1={52} x2={344} y2={290} stroke="#c0392b" strokeWidth="2" strokeDasharray="none"/>
        <text x={272} y={46} textAnchor="end" fontSize="12" fill="#c0392b" fontWeight="700">Magnetic S pole</text>
        <text x={368} y={296} textAnchor="start" fontSize="12" fill="#2E75B6" fontWeight="700">Magnetic N pole</text>

        {/* Field lines looping around Earth */}
        {[
          `M 200,170 C 180,70 320,20 440,170 C 430,280 290,310 200,170`,
          `M 140,170 C 100,20 310,-30 500,170 C 480,340 250,370 140,170`,
          `M 90,170 C 40,-30 300,-80 550,170 C 530,400 210,430 90,170`,
        ].map((d, i) => (
          <path key={i} d={d} fill="none"
            stroke={['#c0392b','#e07b00','#27ae60'][i]}
            strokeWidth="1.6" opacity="0.55" strokeDasharray="none"/>
        ))}

        {/* Declination angle annotation */}
        <path d={`M 320,100 A 30 30 0 0 1 308,103`} fill="none" stroke="#9b59b6" strokeWidth="2"/>
        <text x={328} y={98} fontSize="11" fill="#9b59b6" fontWeight="700">δ ≈ 11°</text>

        {/* Right panel */}
        <rect x={520} y={10} width={370} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={705} y={30} textAnchor="middle" fontSize="15" fill="#7B0D0D" fontWeight="700">Key Facts</text>

        {[
          { y:42,  bg:"#FEF0F0", bc:"#c0392b", lines:["Earth's magnetic field", "Caused by convection of molten iron", "in the outer core (geodynamo)"] },
          { y:114, bg:"#fff5e6", bc:"#e07b00", lines:["Magnetic declination (δ)", "Angle between geographic &", "magnetic north (~11° offset)"] },
          { y:186, bg:"#f0fff4", bc:"#27ae60", lines:["Magnetosphere", "Shields Earth from solar wind", "and cosmic radiation"] },
          { y:258, bg:"#eaf3ff", bc:"#2E75B6", lines:["Reversal", "Earth's poles have reversed", "many times in geological history"] },
        ].map(({y, bg, bc, lines}) => (
          <g key={y}>
            <rect x={526} y={y} width={358} height={68} rx={3} fill={bg} stroke={bc} strokeWidth="1"/>
            <text x={532} y={y+16} fontSize="12" fill="#7B0D0D" fontWeight="700">{lines[0]}</text>
            {lines.slice(1).map((l,i) => <text key={i} x={532} y={y+32+i*16} fontSize="11" fill="#444">{l}</text>)}
          </g>
        ))}
      </svg>
      <div style={S.dCaption}>Earth behaves like a giant bar magnet with field lines looping from the geographic south to north. The magnetic axis is tilted ~11° from the rotational axis, causing magnetic declination — the difference between compass north and true north. The field is generated by the geodynamo in the liquid outer core.</div>
    </div>
  );
}

// ── Diagram 5: The Motor Effect & Fleming's Left-Hand Rule ─────────
function DiagramMotorEffect() {
  const W = 900, H = 320;
  const PW = (W - 30) / 2;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>The Motor Effect — Force on a Current-Carrying Conductor in a Magnetic Field</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>

        {/* Panel 1: Setup */}
        <rect x={10} y={10} width={PW} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={10+PW/2} y={30} textAnchor="middle" fontSize="15" fill="#7B0D0D" fontWeight="700">Force on a Wire (Motor Effect)</text>

        {(()=>{
          const cx = 10+PW/2, cy = 160;
          // Magnetic field dots (into page = cross, out of page = dot)
          const gridX = [80,140,200,260,320,380], gridY = [70,110,150,190,230,270];
          return <>
            {/* Field arrows (out of page) */}
            {gridX.map(gx => gridY.map(gy => (
              <text key={`${gx}-${gy}`} x={gx} y={gy} textAnchor="middle" fontSize="13" fill="#2E75B6" opacity="0.5">•</text>
            )))}
            <text x={cx} y={55} textAnchor="middle" fontSize="12" fill="#2E75B6">B field out of page</text>

            {/* Wire */}
            <rect x={cx-8} y={80} width={16} height={160} rx={4} fill="#e07b00"/>
            {/* Current direction down */}
            <polygon points={`${cx-4},230 ${cx+4},230 ${cx},242`} fill="#fff"/>
            <text x={cx+14} y={246} fontSize="12" fill="#e07b00" fontWeight="700">I ↓</text>

            {/* Force arrow (to the right: F = IL × B) */}
            <line x1={cx+8} y1={cy} x2={cx+80} y2={cy} stroke="#c0392b" strokeWidth="3"/>
            <polygon points={`${cx+80},${cy-6} ${cx+96},${cy} ${cx+80},${cy+6}`} fill="#c0392b"/>
            <text x={cx+100} y={cy+4} fontSize="14" fill="#c0392b" fontWeight="700">F</text>
          </>;
        })()}

        <rect x={16} y={260} width={PW-12} height={48} rx={3} fill="#FEF0F0" stroke="#c0392b" strokeWidth="1"/>
        <text x={22} y={276} fontSize="12" fill="#7B0D0D" fontWeight="700">Force: F = BIL sinθ</text>
        <text x={22} y={293} fontSize="11" fill="#444" fontFamily="'Courier New',monospace">B=field(T), I=current(A), L=length(m)</text>
        <text x={22} y={308} fontSize="11" fill="#444">Maximum when wire ⊥ field (θ=90°)</text>

        {/* Panel 2: Fleming's Left-Hand Rule */}
        <rect x={PW+20} y={10} width={PW} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={PW+20+PW/2} y={30} textAnchor="middle" fontSize="15" fill="#7B0D0D" fontWeight="700">Fleming's Left-Hand Rule</text>

        {(()=>{
          const hx = PW+20+PW/2, hy = 160;
          // Draw stylized hand
          const palm = `${hx-55},${hy+40} ${hx+35},${hy+40} ${hx+35},${hy-10} ${hx-55},${hy-10}`;
          return <>
            {/* Palm */}
            <polygon points={palm} fill="#f5cba7" stroke="#e07b00" strokeWidth="1.5"/>

            {/* Thumb → Force (up) */}
            <rect x={hx-70} y={hy-60} width={18} height={70} rx={6} fill="#c0392b"/>
            <text x={hx-100} y={hy-72} fontSize="12" fill="#c0392b" fontWeight="700">Thumb</text>
            <text x={hx-100} y={hy-58} fontSize="11" fill="#c0392b">= Force</text>

            {/* Index finger → Field (right) */}
            <rect x={hx-10} y={hy-100} width={16} height={90} rx={6} fill="#2E75B6"/>
            <text x={hx-8} y={hy-108} fontSize="12" fill="#2E75B6" fontWeight="700">Index</text>
            <text x={hx-38} y={hy-95} textAnchor="end" fontSize="11" fill="#2E75B6">= B Field</text>

            {/* Middle finger → Current (out toward viewer) */}
            <rect x={hx+22} y={hy-80} width={16} height={70} rx={6} fill="#27ae60"/>
            <text x={hx+44} y={hy-88} fontSize="12" fill="#27ae60" fontWeight="700">Middle</text>
            <text x={hx+44} y={hy-74} fontSize="11" fill="#27ae60">= Current</text>

            {/* Labels at bottom */}
            <rect x={PW+26} y={258} width={PW-12} height={50} rx={3} fill="#eaf3ff" stroke="#2E75B6" strokeWidth="1"/>
            <text x={PW+32} y={274} fontSize="12" fill="#7B0D0D" fontWeight="700">Hold left hand with fingers at 90°:</text>
            <text x={PW+32} y={290} fontSize="11" fill="#444">Index → B (field)  |  Middle → I (current)</text>
            <text x={PW+32} y={306} fontSize="11" fill="#444">Thumb → F (force / motion direction)</text>
          </>;
        })()}
      </svg>
      <div style={S.dCaption}>A current-carrying wire in an external magnetic field experiences a force (the motor effect) given by F = BIL sinθ. Fleming's Left-Hand Rule gives the direction: field (index), current (middle), force (thumb). This is the principle behind electric motors and galvanometers.</div>
    </div>
  );
}

// ── Main ─────────────────────────────────────────────────────────
export default function Magnetism() {
  return (
    <div style={S.wrapper}>
      <h1 style={S.h1}>Magnetism</h1>
      <p style={S.p}>
        Magnetism is one of the fundamental forces of nature, intrinsically linked to electricity through the unified theory of electromagnetism. At its core, magnetic effects arise from the motion of electric charges — whether in an electric current or from the intrinsic spin of electrons within atoms. Understanding magnetism is essential not just for physics, but for understanding electric motors, generators, MRI machines, hard drives, and the protective magnetic shield around our planet.
      </p>

      <InfoBox title="Core Ideas at a Glance" items={[
        "All magnetic fields arise from moving electric charges (current) or intrinsic electron spin",
        "Every magnet has a North and South pole — isolated monopoles have never been found",
        "Unlike poles attract; like poles repel (mirrors electric charge behaviour)",
        "A current-carrying wire creates a magnetic field (Oersted, 1820)",
        "A magnetic field exerts a force on a moving charge: F = qv × B",
        "Electromagnetic induction: a changing magnetic field induces an EMF (Faraday's Law)",
        "Earth itself is a magnet — its field is generated by convection currents in the molten outer core",
      ]}/>

      <h2 style={S.h2}>What Is Magnetism? Atomic Origins</h2>
      <p style={S.p}>
        Magnetism originates at the atomic level. Electrons behave like tiny magnets for two reasons: they carry an electric charge and they orbit the nucleus (orbital magnetic moment), and they possess an intrinsic quantum property called spin. In most materials, electrons pair up with opposite spins and their magnetic effects cancel out. In ferromagnetic materials — iron, cobalt, nickel, and some rare-earth alloys — unpaired electrons align in regions called magnetic domains, producing a net magnetic field.
      </p>
      <Table2 rows={[
        ["Ferromagnetic","Strongly attracted to magnets; can be permanently magnetised\nExamples: iron (Fe), cobalt (Co), nickel (Ni), neodymium (Nd)"],
        ["Paramagnetic","Weakly attracted to magnets; effect disappears when field is removed\nExamples: aluminium, platinum, oxygen"],
        ["Diamagnetic","Weakly repelled by all magnets\nExamples: copper, water, gold, bismuth"],
        ["Magnetic domain","Region where atomic magnets are aligned in the same direction\nIn unmagnetised iron, domains point in random directions"],
        ["Saturation","All domains aligned — maximum possible magnetisation reached"],
        ["Hysteresis","The lag between applied field and magnetisation — energy is lost as heat\nResponsible for permanent magnetism in hard magnetic materials"],
        ["Curie temperature","Temperature above which a ferromagnet loses its permanent magnetism\nIron: 770°C, Nickel: 358°C, Cobalt: 1115°C"],
      ]}/>

      <h2 style={S.h2}>Magnetic Field Lines</h2>
      <p style={S.p}>
        A magnetic field is a region of space where a magnetic force can be detected. We represent it using field lines — imaginary curves whose direction at any point shows the direction of the force on a free north pole, and whose density shows field strength.
      </p>
      <DiagramBarMagnet/>

      <h2 style={S.h2}>Pole Interactions</h2>
      <p style={S.p}>
        The force between two magnets depends on which poles face each other. The rule is simple and absolute: unlike poles attract, like poles repel.
      </p>
      <DiagramPoleInteractions/>
      <Table2 rows={[
        ["Like poles (N–N or S–S)","Repulsive force; field lines bow outward between them\nCannot be overcome by rotating — poles always come in pairs"],
        ["Unlike poles (N–S)","Attractive force; field lines form a smooth bridge\nStrong, short-range — falls off with distance squared"],
        ["Magnetic dipole","A pair of opposite poles separated by a small distance\nEvery magnet is a dipole; cutting a magnet gives two smaller dipoles"],
        ["Monopoles","Not observed in nature — all magnets have two poles\nPredicted theoretically but never detected experimentally"],
        ["Force between magnets","F ∝ (m₁ × m₂) / r²  (analogous to Coulomb's law)\nDoubling distance quarters the force"],
      ]}/>

      <h2 style={S.h2}>Electromagnetism — Current Creates Fields</h2>
      <p style={S.p}>
        In 1820, Hans Christian Oersted discovered that an electric current deflects a compass needle — proving that electricity and magnetism are linked. The magnetic field around a current-carrying wire forms concentric circles, and its direction is given by the Right-Hand Rule.
      </p>
      <DiagramElectromagnetism/>
      <Table2 rows={[
        ["Straight wire","B = μ₀I / (2πr)\nField circles the wire; stronger closer to the wire"],
        ["Right-Hand Rule (wire)","Point thumb in current direction; fingers curl in field direction"],
        ["Solenoid","B = μ₀nI  inside (n = turns per metre, I = current)\nUniform field inside; behaves like a bar magnet outside"],
        ["Toroid","B = μ₀NI / (2πr)  inside the ring; zero outside\nUsed in transformers and MRI machines"],
        ["Electromagnet","Solenoid with iron core — amplifies field by factor μᵣ (relative permeability)\nμᵣ(iron) ≈ 5000; field can be switched on/off"],
        ["Permeability μ₀","μ₀ = 4π × 10⁻⁷ T·m/A (permeability of free space)\nMeasures how easily a field is established in a medium"],
        ["Ampere's Law","∮ B · dl = μ₀ I_enclosed\nRelates the integrated field around a loop to the current it encloses"],
      ]}/>

      <h2 style={S.h2}>Force on a Moving Charge — The Lorentz Force</h2>
      <p style={S.p}>
        A magnetic field exerts a force on any moving charged particle. This force is always perpendicular to both the velocity and the field — it changes the direction of motion but never does work on the charge (it cannot speed it up or slow it down).
      </p>
      <Table2 rows={[
        ["Lorentz force (charge)","F = q(v × B)   →   |F| = qvB sinθ\nq = charge (C), v = speed (m/s), B = flux density (T)"],
        ["Direction","Right-Hand Rule (positive charge): fingers → v, curl toward B, thumb → F\nFor negative charge, reverse direction"],
        ["Circular motion","When v ⊥ B: particle moves in a circle\nr = mv / (qB)   →   radius increases with speed and mass"],
        ["Cyclotron frequency","f = qB / (2πm)\nFrequency of circular orbit — independent of speed (basis of cyclotron)"],
        ["Helical motion","When v has component ∥ B: particle spirals along field lines\nReason why charged particles spiral toward Earth's magnetic poles → aurora"],
        ["Velocity selector","Crossed E and B fields: only particles where qE = qvB pass through\nUsed in mass spectrometers: v = E/B"],
        ["Mass spectrometer","r = mv/(qB) → m/q = rB/v\nMeasures mass-to-charge ratio of ions to identify elements/isotopes"],
      ]}/>

      <h2 style={S.h2}>The Motor Effect</h2>
      <DiagramMotorEffect/>
      <Table2 rows={[
        ["Force on a wire","F = BIL sinθ\nB = flux density (T), I = current (A), L = length (m), θ = angle with B"],
        ["Maximum force","When wire is perpendicular to field (θ = 90°): F = BIL"],
        ["No force","When wire is parallel to field (θ = 0°): F = 0"],
        ["Fleming's Left-Hand Rule","FBI: Field (index finger), Current (middle finger), Force/motion (thumb)\nUsed for motors (conventional current)"],
        ["Electric motor principle","Current in a coil within a magnetic field → torque → rotation\nSplit-ring commutator reverses current every half-turn to sustain rotation"],
        ["Torque on a coil","τ = BINA sinα\nN = turns, A = coil area, α = angle between coil plane and B"],
      ]}/>

      <h2 style={S.h2}>Electromagnetic Induction — Faraday's Law</h2>
      <p style={S.p}>
        In 1831, Michael Faraday discovered the reverse of Oersted's finding: a changing magnetic field induces an electromotive force (EMF) in a conductor. This is the principle behind generators, transformers, and wireless charging.
      </p>
      <Table2 rows={[
        ["Magnetic flux","Φ = BA cosθ   (unit: Weber, Wb = T·m²)\nTotal number of field lines passing through an area A"],
        ["Faraday's Law","EMF = −dΦ/dt   (rate of change of flux)\nMore turns N: EMF = −N dΦ/dt"],
        ["Lenz's Law","Induced current opposes the change that caused it\n(negative sign in Faraday's law — conservation of energy)"],
        ["Fleming's Right-Hand Rule","For generators (motion → current):\nThumb → motion, index → field, middle → induced current"],
        ["AC Generator","Rotating coil in a field → sinusoidal EMF\nEMF = NBAω sin(ωt)   where ω = angular frequency"],
        ["Transformer","Vₛ/Vₚ = Nₛ/Nₚ  (voltage ratio = turns ratio)\nIdeal: Vₚ Iₚ = Vₛ Iₛ  (power conserved)"],
        ["Self-inductance","EMF = −L dI/dt   (L = inductance in Henrys)\nA coil resists changes in its own current"],
        ["Energy in inductor","U = ½LI²  (analogous to ½mv² for kinetic energy)"],
      ]}/>

      <h2 style={S.h2}>Earth's Magnetic Field</h2>
      <DiagramEarthField/>
      <Table2 rows={[
        ["Origin","Geodynamo: convection of liquid iron-nickel in outer core\nGenerates a dipole field similar to a bar magnet"],
        ["Strength at surface","~25–65 μT (microtesla) — much weaker than a fridge magnet (~5 mT)"],
        ["Inclination (dip angle)","Angle between field direction and horizontal\n90° at magnetic poles, 0° at magnetic equator"],
        ["Declination","Angle between magnetic north and geographic north (~11° offset)\nMust be corrected for accurate compass navigation"],
        ["Magnetosphere","Region of space controlled by Earth's field\nDeflects solar wind and protects atmosphere from stripping"],
        ["Pole reversal","Magnetic poles have swapped ~every 300,000 yrs on average\nLast reversal ~780,000 years ago (Brunhes–Matuyama)"],
        ["Aurora borealis/australis","Charged solar particles spiral along field lines to poles\nCollide with atmosphere → emission of light"],
      ]}/>

      <h2 style={S.h2}>Magnetic Materials & Applications</h2>
      <Table2 rows={[
        ["Permanent magnets","Hard magnetic materials (alnico, neodymium-iron-boron)\nHigh coercivity — resist demagnetisation; used in motors, speakers, MRI"],
        ["Electromagnets","Soft iron core + coil; field controlled by current\nUsed in cranes, MRI, particle accelerators, door locks"],
        ["Electric motor","Motor effect: current + field → force → rotation\nDC motors use commutators; AC motors use induction"],
        ["Generator","Electromagnetic induction: rotation → changing flux → EMF\nPower stations, bicycle dynamos, wind turbines"],
        ["Transformer","Transfer AC power at different voltages with minimal loss\nStep-up (increase V) or step-down (decrease V)"],
        ["Magnetic storage","Hard drives store data as magnetised regions on a disk\nRead/write heads detect and change magnetisation direction"],
        ["MRI (Medical Imaging)","~1–3 T superconducting magnet aligns hydrogen protons\nRadio pulses perturb them; emitted signals map soft tissue"],
        ["Maglev trains","Magnetic levitation and propulsion via linear induction motors\nEliminate friction — speeds >600 km/h theoretically possible"],
      ]}/>

      <InfoBox title="Key Formulae Summary" items={[
        "Magnetic force on a charge: F = qvB sinθ  (F in Newtons, q in Coulombs, v in m/s, B in Tesla)",
        "Force on a current-carrying wire: F = BIL sinθ",
        "Magnetic field of a long straight wire: B = μ₀I / (2πr)",
        "Magnetic field inside a solenoid: B = μ₀nI  (n = turns per metre)",
        "Magnetic flux: Φ = BA cosθ  (unit: Weber, Wb)",
        "Faraday's Law: EMF = −N dΦ/dt",
        "Transformer equation: Vₛ/Vₚ = Nₛ/Nₚ",
        "Radius of circular orbit in a magnetic field: r = mv / (qB)",
      ]}/>
    </div>
  );
}